import { render, staticRenderFns } from "./SafariItineraryHelp.vue?vue&type=template&id=047c97f8&scoped=true&"
import script from "./SafariItineraryHelp.vue?vue&type=script&lang=js&"
export * from "./SafariItineraryHelp.vue?vue&type=script&lang=js&"
import style0 from "./SafariItineraryHelp.vue?vue&type=style&index=0&id=047c97f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047c97f8",
  null
  
)

export default component.exports